export default [
  {
    name: 'holdings',
    path: '/holdings',
    component: () => import(/* webpackChunkName: "holdings" */ './views/HoldingsManagement.vue'),
  },

  {
    name: 'holding-details',
    path: '/holdings/:houseFundId',
    props: true,
    component: () => import(/* webpackChunkName: "holdings" */ './views/HoldingDetails.vue'),
  },
];
